import { render, staticRenderFns } from "./VBadge.vue?vue&type=template&id=7b455ce6&scoped=true&"
import script from "./VBadge.vue?vue&type=script&lang=js&"
export * from "./VBadge.vue?vue&type=script&lang=js&"
import style0 from "./VBadge.vue?vue&type=style&index=0&id=7b455ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b455ce6",
  null
  
)

export default component.exports